import { FC } from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'

import Notification from 'components/Notifications/Notification'

import styles from './notification.module.scss'

type Props = {
  notifications?: MData.Notification[]
}
const Notifications: FC<Props> = ({ notifications }) => {
  const notificationsState = useSelector((state: MStore.RootState) => state.notifications.notifications)
  const notificationsList = notifications || notificationsState
  return (
    <div className={clsx('mt-2', 'mx-sm-2', styles.notification, styles['notification-center'], styles['notification-top-right-sm'])}>
      {notificationsList.map(notification => (
        <Notification {...notification} key={notification._id} />
      ))}
    </div>
  )
}

export default Notifications
